import bowl from '../assets/images/bowl liner.jpeg';
import bronze from '../assets/images/Bronze Thrust Bearing.png';
import bush from '../assets/images/bush.JPG';
import feed from '../assets/images/feed plate .jpg';
import gun from '../assets/images/Gun Metal Pins.JPG';
import hammer from '../assets/images/hammer-head.jpg';
import hammerh from '../assets/images/hammerhead-parameters.png';
//import jaw from '../assets/images/jaw-crusher-spares.jpeg';
import PB from '../assets/images/PB_sleeves.JPG';
import Thrust from '../assets/images/Thrust Bearing.jpg';
import thrustt from '../assets/images/Thrust Bearing_1.jpg';
import toggle from '../assets/images/Toggle plate.JPG';
import vibrat from '../assets/images/vibrating screen.JPG';
import side from '../assets/images/Side Plate.jpeg';
const Products4 = [
  { id: 1, name: 'Bowl Liner', image:bowl },
  { id: 2, name: 'Bronze Thrust Bearing', image: bronze },
  { id: 3, name: 'Bush', image: bush },
  { id: 4, name: 'Feed Plate', image: feed },
  { id: 5, name: 'Gun Mental Pins', image: gun },
  { id: 6, name: 'Hammer Head', image: hammer },
  { id: 1, name: 'Hammerhead Parameters', image: hammerh},
  //{ id: 2, name: 'jaw Crusher Spares', image: jaw },
  { id: 3, name: 'PB Sleeves And Bushes', image: PB },
  { id: 4, name: 'Thrust Bearing', image: Thrust },
  { id: 5, name: 'Thrust Bearing_1', image: thrustt},
  { id: 6, name: 'Toggle Plate', image: toggle },
  { id: 1, name: 'Vibrating Screen', image: vibrat},
  { id: 2, name: 'Side Plate', image: side },
 
];

export default Products4;